// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "span[data-v-11c83222]{font-size:.68rem;white-space:nowrap}.indicator[data-v-11c83222]{background:var(--disabled-indicator);border-radius:50%;height:8px;width:8px}.indicator.in-range[data-v-11c83222]{background:var(--access-indicator)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
